/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_ADDVIDEONOTE,ADDVIDEONOTE_RECEIVED } = constants.AddVideoNoteConstant;

export default {
    REQUEST_ADDVIDEONOTE,
    ADDVIDEONOTE_RECEIVED,

  requestAddVideoTag: payload => ({
    type: REQUEST_ADDVIDEONOTE,
    payload
  }),
  AddVideoTagReceived: () => ({
    type: ADDVIDEONOTE_RECEIVED
  }),
};
